import { Skeleton } from 'ui/skeleton';
import { AlertsScrollArea } from './RecentCampaignAlertsList';
import { ClickableCard } from './RecentCampaignAlert';
import { FlexSpacer } from 'ui/flexSpacer';
import { colors, spacing } from 'ui/theme';
import { ChevronRightNew16 } from 'ui/icons/aurora/16px/ChevronRightNew16';

const DEFAULT_NUMBER_OF_SKELETONS = 5;

export const RecentCampaignAlertsSkeleton = () => {
  return (
    <AlertsScrollArea>
      {new Array(DEFAULT_NUMBER_OF_SKELETONS).fill(null).map((_, index) => (
        <ClickableCard key={index}>
          <FlexSpacer justifyContent="space-between" alignItems="center" gap={spacing.threeQuarter}>
            <FlexSpacer alignItems="center" justifyContent="center">
              <Skeleton height={48} width={48} />
            </FlexSpacer>

            <FlexSpacer
              flexDirection="column"
              alignItems="flex-start"
              gap={spacing.half}
              flexGrow={1}
              flexShrink={1}
            >
              <FlexSpacer alignSelf="stretch" flexDirection="column" alignItems="flex-start">
                <Skeleton height={18} width="100%" />
                <Skeleton height={18} width="100%" />
              </FlexSpacer>

              <Skeleton height={14} width="60%" />
            </FlexSpacer>

            <FlexSpacer alignItems="center" justifyContent="center">
              <ChevronRightNew16 color={colors.grey15} />
            </FlexSpacer>
          </FlexSpacer>
        </ClickableCard>
      ))}
    </AlertsScrollArea>
  );
};
